import React, { useContext } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import { AuthContext } from '../contexts/auth';
import { useMutation } from '../hooks/graph';
import Icon from '../components/icon';

// TODO try to move it inside the Navbar component
function NavbarMenu({ user, isAdmin, proxiedUser, onLogout }) {
	return [
		proxiedUser && (
			<div key="a" className="m-2 px-3 py-2 rounded bg-danger text-white text-break">
				<span>Switched to<br/>{proxiedUser.split('@')[0]}@</span>
				{/* <span title={proxiedUser} className="d-block d-lg-none">@</span> */}
			</div>
		),

		<ul key="b" className="nav nav-pills flex-column m-2 mb-5 mb-lg-auto">
			<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
				<NavLink to="/me/dashboard" title="Dashboard" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
					<Icon.ClipboardPulse />
					<span className="nav-link-text">Dashboard</span>
				</NavLink>
			</li>
			{
				// temporal
				isAdmin && <li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
					<NavLink to="/me/report" title="Reporting" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
						<Icon.Speedometer2 />
						<span className="nav-link-text">Reporting?</span>
					</NavLink>
				</li>
			}
			<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
				<NavLink to="/me/connector" title="Brokers and Webhooks" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
					<Icon.CardList />
					<span className="nav-link-text">Brokers &amp; Webhooks</span>
				</NavLink>
			</li>
			<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
				<NavLink to="/me/account" title="Account and Billing" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
					<Icon.Person />
					<span className="nav-link-text">Account &amp; Billing</span>
				</NavLink>
			</li>
			<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
				<NavLink to="/me/documentation" title="Documentation" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
					<Icon.QuestionCircle />
					<span className="nav-link-text">Documentation</span>
				</NavLink>
			</li>
			{
				isAdmin && (
					<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
						<NavLink to="/me/settings" title="Admin settings" className={isActive => 'nav-link' + (isActive ? ' active' : '')}>
							<Icon.Gear />
							<span className="nav-link-text">Admin settings</span>
						</NavLink>
					</li>
				)
			}
		</ul>,

		<ul key="c" className="nav nav-pills flex-column m-2">
			<li className="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#navbarOffcanvas">
				<a href="/" className="nav-link" title="Logout" role="button" onClick={onLogout}>
					<Icon.Power />
					<span className="nav-link-text">Logout</span>
				</a>
			</li>

			<li className="nav-item">
				<a href="https://help.signalstack.com" onClick={() => window.mixpanel?.track('External Link Clicked', {distinct_id: user.id, subject: 'General FAQs'})} className="nav-link py-0" target="_blank" rel="noreferrer"><small>General FAQs</small></a>
			</li>

			<li className="nav-item">
				<a href="https://help.signalstack.com/conversations/new" onClick={() => window.mixpanel?.track('External Link Clicked', {distinct_id: user.id, subject: 'Contact Support'})} className="nav-link py-0" target="_blank" rel="noreferrer"><small>Contact Support</small></a>
			</li>

			<li className="nav-item pt-3">
				<a href="/terms-of-service" onClick={() => window.mixpanel?.track('External Link Clicked', {distinct_id: user.id, subject: 'Terms of service'})} className="nav-link py-0" target="_blank" rel="noreferrer"><small>Terms of service</small></a>
			</li>

			<li className="nav-item">
				<a href="https://signalstack.com/privacy-policy" onClick={() => window.mixpanel?.track('External Link Clicked', {distinct_id: user.id, subject: 'Privacy policy'})} className="nav-link py-0" target="_blank" rel="noreferrer"><small>Privacy policy</small></a>
			</li>

			<li className="nav-item">
				<span className="nav-link disabled"><small>&copy; 2023-25 SignalStack LLC</small></span>
			</li>
		</ul>
	];
}

function Navbar({ history }) {
	const { deauthenticate, isAdmin, proxiedUser, user } = useContext(AuthContext);
	const [ signout ] = useMutation('signout');

	const onLogout = event => {
		signout().then(() => {
			deauthenticate();
		}).catch(() => {});

		// works more "smoothly" than href
		event.preventDefault();
		history.push('/');
	};

	return [
		<div key="lg" className="d-none d-lg-flex flex-column vh-100 bg-light">
			<header className="bg-dddark py-3 px-4">
				{/* <img src="/static/images/logo-small-black.svg" style={{width: '46%'}} className="my-1 mx-auto d-block d-lg-none" /> */}
				<img src="/static/images/logo-black.svg" style={{width: '10em', /* width: '75%' */}} className="my-1" />
			</header>

			<NavbarMenu user={user} isAdmin={isAdmin} proxiedUser={proxiedUser} onLogout={onLogout} />
		</div>,

		<div key="sm" className="navbar fixed-top d-flex d-lg-none bg-light">
			<div className="container-fluid">
				<a className="navbar-brand" href="#">
					<img src="/static/images/logo-black.svg" style={{width: '65%'}} />
				</a>

				<a
					className="navbar-toggler border-0 p-0 ms-auto"
					type="button"
					data-bs-toggle="offcanvas"
					data-bs-target="#navbarOffcanvas"
					aria-controls="navbarOffcanvas"
					aria-label="Toggle navigation"
				>
					<span className="navbar-toggler-icon"></span>
				</a>

				<div className="offcanvas offcanvas-start" tabIndex="-1" id="navbarOffcanvas" aria-labelledby="navbarOffcanvasLabel">
					<div className="offcanvas-header">
						<h5 className="offcanvas-title" id="navbarOffcanvasLabel">Menu</h5>
						<button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
					</div>

					<div className="offcanvas-body px-0 pt-0">
						<NavbarMenu user={user} isAdmin={isAdmin} proxiedUser={proxiedUser} onLogout={onLogout} />
					</div>
				</div>
			</div>
		</div>
	];
}

export default withRouter(React.memo(Navbar));
